import FilterDateNextYear from "./FilterDateNextYear";
const FilterMaturityDate = (props: any) => {
  const before = props?.before;

  return (
    <FilterDateNextYear
      source="limitMaturityDate"
      label="Maturity Date"
      variant="outlined"
      {...props}
    />
  );
};

export default FilterMaturityDate;
